export enum LabelColor
{
    green = "green",
    yellow = "yellow",
    orange = "orange",
    red = "red",
    purple = "purple",
    blue = "blue",
    sky = "sky",
    lime = "lime",
    pink = "pink",
    black = "black",
    none = "null"
}